export default __webpack_public_path__ + "fef56000ce05f1439efe152cdeff3b87.png";